import SearchSongResult from './SearchSongResult'

export default SearchSongResult